const legacyCategoryKey = (group = "") => {
    if (group === "Can See" || group === "Newsfeed") return "newsfeed";
    if (group === "Mapper suggestions") return "mapper";
    return group.trim().toLowerCase().replace(/[^a-z0-9]+/g, "-");
};

export const permissionCategoryKey = (permission = {}) =>
    permission.category || legacyCategoryKey(permission.group);

export const permissionCategoryLabel = (permission, categories = []) => {
    const key = permissionCategoryKey(permission);
    const category = categories.find((item) => item.key === key);
    if (category?.label) return category.label;
    if (permission?.group === "Can See") return "Newsfeed";
    return permission?.group || key || "Permission";
};

export const permissionKindLabel = (permission = {}) =>
    permission.kind === "visibility" ? "Can see" : "Can do";

export const permissionSubtitle = (permission, categories = []) =>
    permissionCategoryLabel(permission, categories) + " · " + permissionKindLabel(permission);

export const availablePermissionCategories = (catalogue = [], categories = []) => {
    const availableKeys = new Set(catalogue.map(permissionCategoryKey));
    const serverCategories = categories
        .filter((category) => availableKeys.has(category.key))
        .sort((left, right) => (left.order || 0) - (right.order || 0));
    const knownKeys = new Set(serverCategories.map((category) => category.key));
    const derived = [];

    catalogue.forEach((permission) => {
        const key = permissionCategoryKey(permission);
        if (!key || knownKeys.has(key)) return;
        knownKeys.add(key);
        derived.push({
            key,
            label: permissionCategoryLabel(permission, categories),
            order: permission.order || Number.MAX_SAFE_INTEGER,
        });
    });

    return [...serverCategories, ...derived];
};

export const permissionsForCategory = (catalogue = [], categoryKey) =>
    catalogue.filter((permission) => permissionCategoryKey(permission) === categoryKey);

export const visibilityPermissions = (catalogue = []) =>
    catalogue
        .filter((permission) => permission.kind === "visibility")
        .sort((left, right) => (left.order || 0) - (right.order || 0));
